import { handleActions } from 'redux-actions';
import { DamzState } from '../../types';
import {
  setAltchaWithMsgToken,
  clearAltchaWithMsgToken,
  setAltchaWithoutMsgToken,
  clearAltchaWithoutMsgToken,
} from '../actions/altcha';
import { toggleStartNewMessage } from '../actions/room';

const initialState: DamzState['altcha'] = {
  withMsgToken: undefined,
  withoutMsgToken: undefined,
};

const altcha = handleActions<DamzState['altcha'], any>(
  {
    [`${setAltchaWithMsgToken}`]: (state, action) => ({
      ...state,
      withMsgToken: action.payload.withMsgToken,
    }),
    [`${clearAltchaWithMsgToken}`]: (state, action) => ({
      ...state,
      withMsgToken: undefined,
    }),
    [`${setAltchaWithoutMsgToken}`]: (state, action) => ({
      ...state,
      withoutMsgToken: action.payload.withoutMsgToken,
    }),
    [`${clearAltchaWithoutMsgToken}`]: (state, action) => ({
      ...state,
      withoutMsgToken: undefined,
    }),
    [`${toggleStartNewMessage}`]: (state, action) => ({
      ...state,
      withMsgToken: undefined,
      withoutMsgToken: undefined,
    }),
  },
  initialState
);

export default altcha;
